/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Division_HrInputs */

const en_mk_mock_division_hr = /** @type {(inputs: Mk_Mock_Division_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HR`)
};

const id_mk_mock_division_hr = /** @type {(inputs: Mk_Mock_Division_HrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HR`)
};

/**
* | output |
* | --- |
* | "HR" |
*
* @param {Mk_Mock_Division_HrInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_division_hr = /** @type {((inputs?: Mk_Mock_Division_HrInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Division_HrInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_division_hr(inputs)
	return en_mk_mock_division_hr(inputs)
});